import Vue from 'vue'
import GetTextPlugin from 'vue-gettext'
import translations from './translations/translations.js'
import router from './router/public'
import store from './store/public'
import MainComponent from './components/layout/MainComponent.vue'
import { API_ROOT } from '@/api/config'
import AuthUser from '@/classes/auth/AuthUser'
import Buefy from 'buefy'
import browserDetect from 'vue-browser-detect-plugin'
import './assets/scss/app.scss'

require('./assets/sass/style.sass')

// Vue swallows component errors, so hand them to the Sentry browser SDK
// loaded in public/index.html. Absent in local builds (no DSN) and
// when its CDN script was blocked.
Vue.config.errorHandler = (err) => {
  if (window.Sentry) {
    window.Sentry.captureException(err)
  }
  console.error(err)
}

Vue.config.productionTip = false
process['API_ENDPOINT'] = API_ROOT
Vue.use(browserDetect)
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en: 'English',
    sv: 'Svenska'
  },
  defaultLanguage: AuthUser.getLanguage() || 'sv',
  translations: translations,
  silent: true
})
Vue.use(Buefy)

Vue.filter('translate', (value) => {
  return !value ? '' : Vue.prototype.$gettext(value.toString())
})

Vue.prototype.$showContactInfo = true

/* eslint-disable no-new */
const app = new Vue({
  template: `<main-component id="main-public" :navbarItems="navbarItems" />`,
  router,
  store,
  components: {
    MainComponent
  },
  data () {
    return {
      navbarItems: [
        {
          destination: '/home',
          text: 'Home',
          exact: true
        },
        {
          destination: '/certificates',
          text: 'Certificates list',
          exact: true
        }
      ]
    }
  }
}).$mount('#app')

if (window.Cypress) {
  window.app = app
}
